import { useState, useEffect } from "react";

import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  InfoWindow,
  Marker,
} from "react-google-maps";
import InfoBox from "react-google-maps/lib/components/addons/InfoBox";
import { useSelector } from "react-redux";
import { YOUR_GOOGLE_MAPS_API_KEY } from "../../store/constants";

const Map = () => {
  // google.maps.fullscreenControl=false;

  const { lat, lng } = useSelector(({ auth }) => auth.coords);

  const MapWithAMarker = withScriptjs(
    withGoogleMap((props) => (
      <GoogleMap
        options={{
          disableDefaultUI: true,
        }}
        defaultZoom={15}
        defaultCenter={{ lat: lat, lng: lng }}
      >
        <Marker
          // onDragEnd={(e) => {
          //   console.log(e.latLng.lat()); }}
          // draggable={true}
          position={{ lat: lat, lng: lng }}
        />
      </GoogleMap>
    ))
  );

  return (
    <MapWithAMarker
      googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${YOUR_GOOGLE_MAPS_API_KEY}&v=3.exp&libraries=geometry,drawing,places`}
      loadingElement={
        <div
          style={{
            height: `100%`,
            height: "200px",
            backgroundColor: "#e3e3e3",
          }}
        />
      }
      containerElement={<div style={{ height: `200px` }} />}
      mapElement={<div style={{ height: `100%` }} />}
    />
  );
};

export default Map;
